import React, { useState } from 'react';
import { KeyRound, Save, Loader2, CheckCircle2, ShieldAlert } from 'lucide-react';
import { api } from '../../lib/api';
import { Field, TextInput, Button } from '../../components/admin/FormControls';

const AdminPassword = () => {
  const [form, setForm] = useState({
    current_password: '',
    new_password: '',
    confirm: ''
  });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    setMsg('');
    if (form.new_password !== form.confirm) {
      setErr('New passwords do not match');
      return;
    }
    if (form.new_password.length < 8) {
      setErr('New password must be at least 8 characters');
      return;
    }
    setSaving(true);
    try {
      await api.post('/auth/change-password', {
        current_password: form.current_password,
        new_password: form.new_password
      });
      setMsg('Password updated successfully.');
      setForm({ current_password: '', new_password: '', confirm: '' });
    } catch (e) {
      setErr(e?.response?.data?.detail || 'Failed to update password');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-xl">
      <h1 className="mb-1 font-serif text-3xl font-bold text-[#0B2545]">Change Password</h1>
      <p className="mb-6 text-[13.5px] text-[#0B2545]/65">
        Keep your administrator account secure with a strong, unique password.
      </p>

      <form onSubmit={submit} className="rounded-lg border border-[#E6DDC8] bg-white p-6 shadow-sm">
        <div className="mb-5 flex items-center gap-3 rounded-md border border-[#E6DDC8] bg-[#FAF6EC] p-3 text-[12.5px] text-[#0B2545]/75">
          <ShieldAlert size={16} className="shrink-0 text-[#C9A86A]" />
          Use at least 8 characters with a mix of letters, numbers and symbols.
        </div>
        <div className="space-y-4">
          <Field label="Current password">
            <TextInput
              type="password"
              value={form.current_password}
              onChange={(v) => setForm({ ...form, current_password: v })}
            />
          </Field>
          <Field label="New password">
            <TextInput
              type="password"
              value={form.new_password}
              onChange={(v) => setForm({ ...form, new_password: v })}
            />
          </Field>
          <Field label="Confirm new password">
            <TextInput
              type="password"
              value={form.confirm}
              onChange={(v) => setForm({ ...form, confirm: v })}
            />
          </Field>
        </div>

        {err && (
          <div className="mt-4 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-[13px] text-red-700">
            {err}
          </div>
        )}
        {msg && (
          <div className="mt-4 inline-flex items-center gap-2 rounded-md border border-green-200 bg-green-50 px-3 py-2 text-[13px] text-green-700">
            <CheckCircle2 size={14} /> {msg}
          </div>
        )}

        <div className="mt-6 flex items-center justify-end">
          <Button type="submit" disabled={saving}>
            {saving ? <Loader2 size={13} className="animate-spin" /> : <KeyRound size={13} />}
            Update password
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AdminPassword;
